<template>
    <div class="header_div">
      <div class="h_bloc1">
      <img src="../assets/logo/logo-header2.png" alt="logo PreventTms" class='img-header'/>
      </div>
      <div class="h_bloc2">
        <div class="cercle-prenom" v-on:click="burger()">
          {{ lettre() }}
        </div>
        <div  :class="[ active === true ? 'activeBurger' : 'hide']" id="burger">
          <ul class="ul-burger">
            <li v-on:click="burger()" class="li-burger">
              <router-link  to="/questionnaire" title="questionnaire"  class="a-burger">Vos informations</router-link>
            </li>
            <li v-on:click="burger()" class="li-burger" >
              <router-link  to="/contre-indication" title="indicateurs" class="a-burger" >Vos douleurs</router-link>
            </li>
            <li v-on:click="burger()" class="li-burger" >
              <a href="#" title="Plein Ecran" class="a-burger" v-on:click="onClickiki()" >
                  {{ ecran }}
                </a>
            </li>
            <li v-on:click="burger()" class="li-burger">
              <router-link  to="/deconnexion" title="se déconnecter" class="a-burger" >Se déconnecter</router-link>
            </li>
          </ul>
        </div>
        </div>
      
    </div>
</template>

<script>
import { User } from "../controller/user.js";
import * as controle from "../controller/correctionEcran.js";


export default {
  name: "Header",
  data() {
    return {
        user: JSON.parse(localStorage.user)|| [],
        active: false,
        ecran: "Plein Ecran",
    };
  },
  created(){
    if (typeof(localStorage.user) !== undefined && localStorage.length > 1 ){
      try {
        JSON.parse(localStorage.user);
        this.user = JSON.parse(localStorage.user);
      } catch (error) {
        this.$router.push({ name: 'connexion' });
      } 
    }
  },
  methods:{
    burger() {
      if (this.active == false){
        this.active = true;
        setTimeout(() => this.active=false, 5000);
      }else{
        this.active = false;
      }
      ;
    },
    deco(){
      localStorage.clear();
      this.$router.push({ name: 'connexion' });
    },
    lettre(){
      //console.log(this.user.prenom.substr(0, 1).toUpperCase())
      if (this.user.prenom !== undefined){
        return this.user.prenom.substr(0, 1).toUpperCase();
      }else if(this.user.nom !== undefined){
        return this.user.nom.substr(0, 1).toUpperCase();
      }else if(this.user.mail !== undefined){
        return this.user.mail.substr(0, 1).toUpperCase();
      }else{
        return 'X';
      }
    },
    onClickiki(){
      let gogo = controle.oneClick();
      if (gogo == 0){
        this.ecran = "Plein Ecran";
      }else{
        this.ecran = "Annuler plein ecran";
      }
    },
  },
  beforeRouteLeave(to, from, next){
    this.active = false;
    next();
  }

};
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/Header.vue